module.exports = (__parcel__import__("duwn5")).then(() => parcelRequire('ieIpp'));